export const VARS = {
  GRAY_100: '#F5F5F5',
  GRAY_200: '#EEEEEE',
  GRAY_300: '#AFAFAF',
  GRAY_50: '#FAFAFA',
  GRAY_250: '#E0E0E0',
  GRAY_270: '#d0d0d0',
  GRAY_900: '#212121',
  GRAY_600: '#757575',
  GRAY_400: '#BDBDBD',

  YELLOW_100: '#FDFAEC',
  YELLOW_500: '#FFF4D1',
  
  AMBER_400: '#FFF7E1',
  AMBER_500: '#FFCD39',

  RED_400: '#FEECEC',

  PRIMARY_OUTLINED_HOVER_BACKGROUND: '#3F51B514',
  TEXT_SECONDARY: 'rgba(0, 0, 0, 0.6)',
  TEXT_SECONDARY_54: 'rgba(0, 0, 0, 0.54)',
  PRIMARY: 'rgba(0, 0, 0, 0.87)',
  TEXT_DISABLED: '#00000061',
  TEXT_PRIMARY: '#000000DE',
  DISABLED: 'rgba(0, 0, 0, 0.38)',

  BLUE_100: '#E9ECF8',
  BLUE_MAIN: '#3F51B5',
  BLUE_MAIN_HOVER: 'linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), #3F51B5',
  BLUE_BG: '#ECEAF8',
  BLUE_HL: '#5020b2',

  SECONDARY: '#F50057',
  
  PRIMARY_LIGHT: '#7986CB',
  
  ACTION_ACTIVE: 'rgba(0, 0, 0, 0.54)',
  ACTION_HOVER: 'rgba(0, 0, 0, 0.04)',
  
  ERROR_MAIN: '#d32f2f',
  INDIGO_100: '#E9ECF8',
  RATING_ACTIVE: '#FFB400',
  ERROR_DARK: '#E31B0C',
  GREEN_100: '#E8FAE9',
  LINK_TEXT: '#2C3AAD',
  SUCCESS: '#4CAF50',
  SUCCESS_DARK: '#3B873E',
  WHITE: '#FFFFFF',
  WARNING_DARK: '#C77700',

  // Цвета мессенджеров
  MESSENGER_WHATSAPP: '#D2F1E0',
  MESSENGER_TELEGRAM: '#D6ECFA',
  MESSENGER_MAX: '#D9E8FF',
  MESSENGER_VIBER: '#E8D6F5',

  BORDER_RADIUS_CONTROLS: '12px',
  BORDER_RADIUS_BASE: '4px',
  BORDER_RADIUS_COMMON: '8px',

  // Отступы для диалогов на мобильных (theme.spacing(6) = 48px)
  DIALOG_MARGIN_MOBILE: '48px',

  KNM_TINTS_RED: '#feebeb',

  TOOLTIP: 'rgba(97, 97, 97, 0.9)',

  KNM_RED: '#F76764', // KNM Tints Red 500 (80%)
  KNM_RED_500: '#F5413D', // KNM Tints Red 500 (100%) — долг/остаток
  KNM_GREEN_500: '#33A533', // KNM Tints Green 500 — оплачено

  /* Палитра статусов брони (KNM-136, новая форма бронирования).
     Точки — токены KNM Tints */
  STATUS_DOT_NOT_CONFIRMED: '#F0D042', // KNM Tints Yellow 500 (100%)
  STATUS_DOT_CONFIRMED: '#008E00', // KNM Tints Green 500 (100%)
  STATUS_DOT_STAY: '#1672EC', // KNM Tints Blue 500 (100%)
  STATUS_DOT_DEPARTURE: '#9A0FBF', // KNM Tints Purple 500 (100%)

  /* Подложки плашки статуса. В токенах задан только жёлтый — KNM Tints Yellow 100 (80%) = #FCF5D9,
     что равно Yellow 500 при 20% на белом (240·0.2+255·0.8 = 252 и т.д.).
     Остальные выведены тем же преобразованием из своих 500-оттенков — заменить,
     когда в макете появятся Green/Blue/Purple 100 (80%). */
  STATUS_BG_NOT_CONFIRMED: '#FCF5D9', // KNM Tints Yellow 100 (80%) — из токена
  STATUS_BG_CONFIRMED: '#CCE8CC', // Green 500 @ 20% на белом
  STATUS_BG_STAY: '#D0E3FB', // Blue 500 @ 20% на белом
  STATUS_BG_DEPARTURE: '#EBCFF2', // Purple 500 @ 20% на белом

  BUTTON_RADIUS: '100px',
  SECONDARY_HOVER: '#C9CFEE',
}